// This composable is for shared functionality across Journey Builder form pages, since they all require async
// submits that wait for a workflow progress value.
import { useStore } from 'vuex';
import Network from '../../lib/api/network';

// redirectPath is a func because the workflow doesn't exist yet in the first page that uses this.
const useJourneyBuilderFormSubmission = (expectedProgress, redirectPathFunc) => {
  const { commit, dispatch } = useStore();

  const handleError = () => {
    dispatch('setErrorToast', 'There was an unexpected error. Try again?', { root: true });
    commit('update', { key: 'formSubmitted', value: false }, { root: true });
  };

  const pollForWorkflowProgress = (workflowId) => new Promise((resolve) => {
    Network.get(
      `/journey_builder/${workflowId}`,
      {
        success: (workflow) => {
          commit('update', { key: 'journeyBuilderWorkflow', value: workflow }, { root: true });
          if (workflow.progress === expectedProgress) {
            window.location.href = redirectPathFunc(workflow);
          } else if (workflow.progress !== 'requires_user_info_for_events') {
            setTimeout(() => {
              resolve(pollForWorkflowProgress(workflowId));
            }, 2000);
          }
          resolve(workflow);
        },
        error: handleError,
      },
    );
  });

  const submitJourneyBuilderForm = (submitPath, formData) => {
    commit('update', { key: 'formSubmitted', value: true }, { root: true });
    Network.post(
      submitPath,
      formData,
      {
        success: (workflow) => {
          pollForWorkflowProgress(workflow.id);
        },
        error: handleError,
      },
    );
  };


  return { submitJourneyBuilderForm, pollForWorkflowProgress };
};

export default useJourneyBuilderFormSubmission;
